import React, { useLayoutEffect, useRef } from 'react'
import { Box } from '@roo/roo'
import { useTranslation } from '@sailor/i18n-web'
import styles from './index.module.less'
import Container from '@/components/Container'
import HighlightText from '../HighlightText'
import { picUrl } from '@/common/utils/consts'
import { useLocation, useNavigate } from 'react-router-dom'

interface CaseItemProps {
  companyName: string;
  employeeCount: string;
  content: string;
  position: string;
}

const CaseItem: React.FC<CaseItemProps> = ({ companyName, employeeCount, content, position }) => (
  <div className={styles.caseItem} style={{ backgroundImage: `url(${picUrl.comma})` }}>
    {/* <div className={styles.header}>
      <span className={styles.companyName}>{companyName}</span>
      <span className={styles.divider}>|</span>
      <span className={styles.employeeCount}>{employeeCount}</span>
    </div> */}
    <p className={styles.content}>{content}</p>
    <p className={styles.position} style={{ opacity: 0, userSelect: 'none' }}>—— {position}</p>
    <p className={styles.position} style={{ position: 'absolute', bottom: '3.2rem', right: '3.2rem', left: '3.2rem' }}>—— {position}</p>
  </div>
)

const CooperationCases: React.FC = () => {
  const { t } = useTranslation()
  const location = useLocation()
  const navigate = useNavigate()
  const containerRef = useRef<HTMLDivElement>(null)

  const cases = [
    {
      companyName: '',
      employeeCount: '',
      content: t('ent_o_home_case_1_content'),
      position: t('ent_o_home_case_1_position'),
    },
    {
      companyName: '',
      employeeCount: '',
      content: t('ent_o_home_case_2_content'),
      position: t('ent_o_home_case_2_position'),
    },
    {
      companyName: '',
      employeeCount: '',
      content: t('ent_o_home_case_3_content'),
      position: t('ent_o_home_case_3_position'),
    },
    {
      companyName: '',
      employeeCount: '',
      content: t('ent_o_home_case_4_content'),
      position: t('ent_o_home_case_4_position'),
    },
  ]

  useLayoutEffect(() => {
    if (location?.hash?.includes('cooperationCases') && containerRef.current) {
      containerRef.current.scrollIntoView({ behavior: 'smooth' })
      navigate('/', { replace: true })  // 更新路由
    }
  }, [location])

  return (
    <div ref={containerRef}>
      <Container className={styles.cooperationCases} gray style={{ paddingBottom: '0' }}>
        <div className={styles.cooperationCases}>
          <h2 className={`${styles.title} section-title`}>
            <HighlightText>{t('ent_o_home_cooperate_vnja', '合作')}</HighlightText>
            <span>{t('ent_o_home_cooperate_vnjaCase_1nsH', '案例')}</span>
          </h2>

        </div>
      </Container>
      <Container className={styles.cooperationCases} gray style={{ paddingTop: '0' }} contentClassName={styles.casesContainer}>
        <Box  className={styles.container} >
          <div className={styles.casesGrid}
          >
            {cases.map((item, index) => (
              <CaseItem
                key={index}
                companyName={item.companyName}
                employeeCount={item.employeeCount}
                content={item.content}
                position={item.position}
              />
            ))}
          </div>
        </Box>
      </Container>
    </div>
  )
}

export default CooperationCases
